(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-brands-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-brand-gallery')) {
    customElements.define('pe-brand-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pebg__grid');
        this.nav = this.querySelector('.pebg__navigation');
        if (!this.track || !this.nav) return;
        this.previous = this.querySelector('[data-pebg-prev]');
        this.next = this.querySelector('[data-pebg-next]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      move(step) {
        const item = this.track.querySelector('.pebg__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: step * direction * (item.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.min(Math.abs(this.track.scrollLeft), maximum);
        this.nav.hidden = maximum <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
        const visibleFraction = this.track.clientWidth / Math.max(this.track.scrollWidth, 1);
        this.style.setProperty('--pebg-progress', visibleFraction + (1 - visibleFraction) * (maximum > 0 ? position / maximum : 1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-luxe-scrolling-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  const instances = new WeakMap();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cleanClone(node) {
    const clone = node.cloneNode(true);
    const elements = [clone, ...clone.querySelectorAll('*')];
    elements.forEach((element) => {
      Array.from(element.attributes).forEach((attr) => {
        if (attr.name === 'id' || attr.name === 'data-pe-block' || attr.name.indexOf('data-shopify-') === 0) {
          element.removeAttribute(attr.name);
        }
      });
      if (element.matches('a,button,input,select,textarea,[tabindex]')) {
        element.setAttribute('tabindex', '-1');
      }
    });
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('role');
    return clone;
  }

  function rootsWithin(target) {
    const roots = [];
    if (target && target.matches && target.matches('[data-pe-minimal-marquee]')) roots.push(target);
    if (target && target.querySelectorAll) roots.push(...target.querySelectorAll('[data-pe-minimal-marquee]'));
    return roots;
  }

  function init(root) {
    if (instances.has(root)) return;
    const viewport = root.querySelector('.pe-luxe-marquee__viewport');
    const track = root.querySelector('.pe-luxe-marquee__track');
    if (!viewport || !track) return;
    const groups = track.querySelectorAll('.pe-luxe-marquee__group');
    if (groups.length !== 2) return;
    const [primary, duplicate] = groups;
    const originals = Array.from(primary.children);
    if (!originals.length) return;
    let raf = 0;
    let destroyed = false;
    let selectedId = null;

    function focusBlock() {
      if (!selectedId) return;
      const original = Array.from(primary.children).find((el) => el.getAttribute('data-pe-block') === selectedId);
      if (!original) return;
      const viewportWidth = viewport.clientWidth;
      const offset = viewportWidth / 2 - (original.offsetLeft + original.offsetWidth / 2);
      root.style.setProperty('--pe-m-editor-offset', offset + 'px');
      root.classList.add('pe-luxe-marquee--editor-focused');
    }

    function rebuild() {
      raf = 0;
      if (destroyed) return;
      root.classList.remove('pe-luxe-marquee--ready', 'pe-luxe-marquee--measuring', 'pe-luxe-marquee--editor-focused');
      primary.replaceChildren(...originals);
      duplicate.replaceChildren();
      if (!root.classList.contains('pe-luxe-marquee--animate') || reduceMotion.matches || !viewport.clientWidth) {
        if (selectedId) focusBlock();
        return;
      }
      root.classList.add('pe-luxe-marquee--measuring');
      const targetWidth = viewport.clientWidth + 4;
      let lastWidth = 0;
      let repeats = 0;
      // Width-adaptive repetition: prevents blank stretches with just one short item.
      while (repeats < 160) {
        const width = primary.getBoundingClientRect().width;
        if (width >= targetWidth || (repeats > 0 && width <= lastWidth)) break;
        lastWidth = width;
        originals.forEach((node) => primary.appendChild(cleanClone(node)));
        repeats += 1;
      }
      const ghostNodes = Array.from(primary.children, cleanClone);
      duplicate.replaceChildren(...ghostNodes);
      root.classList.remove('pe-luxe-marquee--measuring');
      root.classList.add('pe-luxe-marquee--ready');
      if (selectedId) focusBlock();
    }

    function schedule() {
      if (destroyed || raf) return;
      raf = window.requestAnimationFrame(rebuild);
    }

    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
    if (observer) observer.observe(viewport);
    else window.addEventListener('resize', schedule);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', schedule);
    else reduceMotion.addListener(schedule);
    instances.set(root, {
      schedule,
      select(blockId) { selectedId = blockId; root.classList.add('pe-luxe-marquee--editor-paused'); focusBlock(); },
      deselect() { selectedId = null; root.classList.remove('pe-luxe-marquee--editor-paused', 'pe-luxe-marquee--editor-focused'); root.style.removeProperty('--pe-m-editor-offset'); },
      pause() { root.classList.add('pe-luxe-marquee--editor-paused'); },
      unpause() { root.classList.remove('pe-luxe-marquee--editor-paused'); },
      destroy() {
        destroyed = true;
        window.cancelAnimationFrame(raf);
        if (observer) observer.disconnect();
        else window.removeEventListener('resize', schedule);
        if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', schedule);
        else reduceMotion.removeListener(schedule);
        instances.delete(root);
      }
    });
    schedule();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  function initAll(target) { rootsWithin(target || document).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    rootsWithin(e.target).forEach((root) => { const instance = instances.get(root); if (instance) instance.destroy(); });
  });
  document.addEventListener('shopify:section:select', (e) => {
    rootsWithin(e.target).forEach((root) => { const instance = instances.get(root); if (instance) instance.pause(); });
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    rootsWithin(e.target).forEach((root) => { const instance = instances.get(root); if (instance) instance.unpause(); });
  });
  document.addEventListener('shopify:block:select', (e) => {
    const blockId = e.detail && e.detail.blockId;
    if (!blockId) return;
    const root = e.target.closest && e.target.closest('[data-pe-minimal-marquee]');
    if (root && instances.has(root)) instances.get(root).select(blockId);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const root = e.target.closest && e.target.closest('[data-pe-minimal-marquee]');
    if (root && instances.has(root)) instances.get(root).deselect();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-product-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pe-collection-tabs')) {
  class PeCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[data-collection-tab]'));
      this.carousel = this.querySelector('pe-carousel, pe-product-carousel');
      this.track = this.querySelector('[data-tab-track]');
      this.panel = this.querySelector('[data-tab-panel]');
      this.message = this.querySelector('[data-tab-message]');
      this.viewAllLinks = Array.from(this.querySelectorAll('[data-view-all-link]'));
      if (!this.tabs.length || !this.track || !this.carousel) return;
      this.generation = 0;
      this.cache = new Map();
      this.cache.set(this.dataset.defaultUrl, this.track.innerHTML);
      if (!this.track.children.length) this.showMessage(this.dataset.emptyText);
      const signal = this.abort.signal;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(tab);
        }, { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            const rtl = getComputedStyle(this).direction === 'rtl';
            next = (index + ((event.key === 'ArrowLeft') === rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
          }
          if (next === undefined) return;
          event.preventDefault();
          this.tabs[next].focus({ preventScroll: true });
          this.select(this.tabs[next]);
        }, { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.blockId === event.detail?.blockId);
        if (tab) this.select(tab);
      }, { signal });
      const activeTab = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
      if (activeTab) this.updateViewAllLinks(activeTab);
      if (!this.tabs.some(tab => tab.hasAttribute('data-default-tab'))) this.select(this.tabs[0]);
    }
    async select(tab) {
      if (tab.getAttribute('aria-selected') === 'true' && !this.hasAttribute('data-loading')) return;
      const generation = ++this.generation;
      this.request?.abort();
      this.request = new AbortController();
      const controller = this.request;
      const key = tab.dataset.collectionUrl;
      this.setAttribute('data-loading', '');
      this.panel.setAttribute('aria-busy', 'true');
      this.showMessage(this.dataset.loadingText);
      let timeout;
      try {
        let items = this.cache.get(key);
        if (!items) {
          const url = new URL(key, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid collection origin');
          url.searchParams.set('view', 'pe-tabs');
          timeout = setTimeout(() => controller.abort(), 10000);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection could not be loaded');
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const source = parsed.querySelector('[data-pe-tab-source]');
          if (!source) throw new Error('Product markup is missing');
          items = this.prepareItems(source);
          this.cache.set(key, items);
        }
        await customElements.whenDefined(this.carousel.localName);
        if (generation !== this.generation || !this.isConnected) return;
        const template = document.createElement('template');
        template.innerHTML = items;
        this.carousel.setItems(template.content);
        this.tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panel.setAttribute('aria-labelledby', tab.id);
        this.updateViewAllLinks(tab);
        this.showMessage(this.track.children.length ? '' : this.dataset.emptyText);
      } catch (error) {
        if (generation === this.generation && this.isConnected) this.showMessage(this.dataset.errorText);
      } finally {
        clearTimeout(timeout);
        if (generation === this.generation && this.isConnected) {
          this.removeAttribute('data-loading');
          this.panel.setAttribute('aria-busy', 'false');
        }
      }
    }
    updateViewAllLinks(tab) {
      const url = tab.dataset.collectionUrl;
      if (!url) return;
      this.viewAllLinks.forEach(link => link.setAttribute('href', url));
    }
    prepareItems(source) {
      const template = document.createElement('template');
      const fragment = template.content;
      const items = Array.from(source.children)
        .filter(item => this.dataset.hideSoldOut !== 'true' || item.dataset.available === 'true')
        .slice(0, Number(this.dataset.limit));
      items.forEach(item => {
        const vendor = item.querySelector('[data-pe-tab-vendor]');
        if (this.dataset.showVendor === 'true' && vendor) {
          vendor.hidden = false;
          vendor.className = 'caption-with-letter-spacing light';
          item.querySelector('.card__information')?.append(vendor);
        } else vendor?.remove();
        if (this.dataset.secondImage !== 'true') item.querySelectorAll('.card__media .media img:not(:first-child)').forEach(image => image.remove());
        if (this.dataset.quickAdd !== 'true') item.querySelectorAll('.quick-add,quick-add-modal,quick-add-bulk').forEach(element => element.remove());
        fragment.append(item);
      });
      const ids = new Map();
      fragment.querySelectorAll('[id]').forEach(element => {
        const id = element.id + '-' + this.dataset.sectionId;
        ids.set(element.id, id);
        element.id = id;
      });
      fragment.querySelectorAll('[for],[form],[aria-labelledby],[aria-describedby],[aria-controls],[data-modal],[href]').forEach(element => {
        ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'data-modal', 'href'].forEach(attribute => {
          const value = element.getAttribute(attribute);
          if (!value) return;
          const updated = value.split(/\s+/).map(token => {
            if (ids.has(token)) return ids.get(token);
            if (token.startsWith('#') && ids.has(token.slice(1))) return '#' + ids.get(token.slice(1));
            return token;
          }).join(' ');
          if (updated !== value) element.setAttribute(attribute, updated);
        });
      });
      return template.innerHTML;
    }
    showMessage(text) {
      if (!this.message) return;
      this.message.textContent = text || '';
      this.message.hidden = !text;
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.abort?.abort();
      this.request?.abort();
      this.cache?.clear();
    }
  }
  customElements.define('pe-collection-tabs', PeCollectionTabs);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pe-product-shortcut')){customElements.define('pe-product-shortcut',class extends HTMLElement{connectedCallback(){const info=document.querySelector('.pe-product-main .product__info-container');if(!info)return;this.querySelector('a').href='#'+info.id;this.observer=new IntersectionObserver(entries=>{this.classList.toggle('is-visible',!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0)},{threshold:0});this.observer.observe(info)}disconnectedCallback(){this.observer?.disconnect()}})}

  } catch(e) { console.error(e); }
})();
})();
